<script lang="ts">
	import type { Device } from 'src/types/Device';

	import EmeterAdvancedView from 'src/components/Sidepanel/DeviceViews/Emeter/EmeterAdvancedView.svelte';

	export let device: Device;
</script>

<EmeterAdvancedView {device} />
